import React from 'react';
import { Box } from '@mui/material';
import {
  Assignment as TaskIcon,
  People as PeopleIcon,
  CalendarToday as CalendarIcon,
  Event as EventIcon,
} from '@mui/icons-material';
import { StaffStats } from '../../../types/statistics';
import { StatCard } from '../StatCard';
import { DashboardTabs } from '../DashboardTabs';

interface StaffViewProps {
  data: StaffStats;
}

export const StaffView: React.FC<StaffViewProps> = ({ data }) => {
  return (
    <DashboardTabs overviewType="staff">
      <Box sx={{ display: 'flex', flexWrap: 'wrap', mx: -1.5 }}>
        <Box sx={{ width: { xs: '100%', sm: '50%', md: '25%' }, p: 1.5 }}>
          <StatCard
            title="Assigned Tasks"
            value={data.my_assigned_tasks}
            icon={<TaskIcon />}
            color="#2563eb"
          />
        </Box>
        <Box sx={{ width: { xs: '100%', sm: '50%', md: '25%' }, p: 1.5 }}>
          <StatCard
            title="Pending Tasks"
            value={data.my_pending_tasks}
            icon={<TaskIcon />}
            color="#ea580c"
          />
        </Box>
        <Box sx={{ width: { xs: '100%', sm: '50%', md: '25%' }, p: 1.5 }}>
          <StatCard
            title="Completed Tasks"
            value={data.my_completed_tasks}
            icon={<TaskIcon />}
            color="#16a34a"
          />
        </Box>
      </Box>

      <Box sx={{ display: 'flex', flexWrap: 'wrap', mx: -1.5 }}>
        <Box sx={{ width: { xs: '100%', sm: '50%', md: '25%' }, p: 1.5 }}>
          <StatCard
            title="My Contacts"
            value={data.my_contacts}
            icon={<PeopleIcon />}
            color="#9333ea"
          />
        </Box>
        <Box sx={{ width: { xs: '100%', sm: '50%', md: '25%' }, p: 1.5 }}>
          <StatCard
            title="Calendar Events"
            value={data.my_calendar_events}
            icon={<CalendarIcon />}
            color="#2563eb"
          />
        </Box>
        <Box sx={{ width: { xs: '100%', sm: '50%', md: '25%' }, p: 1.5 }}>
          <StatCard
            title="Upcoming Events"
            value={data.upcoming_events}
            icon={<EventIcon />}
            color="#dc2626"
          />
        </Box>
      </Box>
    </DashboardTabs>
  );
};
